Wee.fn.make('flushHeights', {
	init: function() {
		// ...
	}
}, {
	/* TODO: Optimize this function so it's storing the $elements variable in the private object, instead of calling it every time redraw is fired */
	size: function(refContainer, ref) {
		var $elements = $('ref:' + ref),
			$elementHeights = $elements.map(function(el) {
				return $(el).height();
			});

		$('ref:' + refContainer).height(Math.max.apply(null, $elementHeights));

		this.refContainer = refContainer;
		this.ref = ref;
	}
});